export var WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE = 2;
export var WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL = 0.5625;
export var WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE = 1.78; // 16 (width) / 9 (height)
export var WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT = 0.5625; // 9 (width) / 16 (height)
export var TINY_IMAGE_WIDTH_THRESHOLD = 50;
export var TINY_IMAGE_HEIGHT_THRESHOLD = 50;
export var TINY_IMAGE_SIZE_MULTIPLIER = 2;
export var CHARS_BEFORE_LONG_STATUS = 110;
//# sourceMappingURL=constants.js.map